export const orderConstants = {
  GET_ORDER_STATE_REQUEST: 'GET_ORDER_STATE_REQUEST',
  GET_ORDER_STATE_SUCCESS: 'GET_ORDER_STATE_SUCCESS',
  GET_ORDER_STATE_FAILURE: 'GET_ORDER_STATE_FAILURE',

  PROCESS_ORDER_REQUEST: 'PROCESS_ORDER_REQUEST',
  PROCESS_ORDER_SUCCESS: 'PROCESS_ORDER_SUCCESS',
  PROCESS_ORDER_FAILURE: 'PROCESS_ORDER_FAILURE'
};
